export enum ALLOWED_FIELDS {
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  REMINDER_PERIOD = 'reminderPeriod',
  LAST_REMINDER_PERIOD = 'lastReminderPeriod',
  REMINDER_FREQUENCY = 'reminderFrequency',
  ACH_DESCRIPTION = 'achievementDescription',
  ACH_TARGET = 'achievementTarget',
  ACH_PERIOD = 'achievementPeriod',
  ACH_FREQUENCY = 'achievementFrequency',
  LAST_ACH_ENTERED = 'lastAchievementEntered',
  LAST_ACH_DATE = 'lastAchievementEnteredDate',
}

export const DEFAULT_TEMPLATE =
  `Hey {{${ALLOWED_FIELDS.FIRST_NAME}}} {{${ALLOWED_FIELDS.LAST_NAME}}},\n` +
  `We're checking in to ask for your progress on your goal: {{${ALLOWED_FIELDS.ACH_DESCRIPTION}}}.\n` +
  `{{${ALLOWED_FIELDS.LAST_REMINDER_PERIOD}}} your entry was: {{${ALLOWED_FIELDS.LAST_ACH_ENTERED}}}.\n` +
  `What is your achievement {{${ALLOWED_FIELDS.REMINDER_PERIOD}}}?`;

export const DEFAULT_OPTIONS: Array<{value: ALLOWED_FIELDS; label: string}> = [
  {
    value: ALLOWED_FIELDS.FIRST_NAME,
    label: '[first name]',
  },
  {
    value: ALLOWED_FIELDS.LAST_NAME,
    label: '[last name]',
  },
  {
    value: ALLOWED_FIELDS.REMINDER_FREQUENCY,
    label: '[reminder frequency]',
  },
  {
    value: ALLOWED_FIELDS.REMINDER_PERIOD,
    label: '[reminder period]',
  },
  {
    value: ALLOWED_FIELDS.ACH_PERIOD,
    label: '[achievement period]',
  },
  {
    value: ALLOWED_FIELDS.ACH_TARGET,
    label: '[achievement target]',
  },
  {
    value: ALLOWED_FIELDS.ACH_DESCRIPTION,
    label: '[achievement description]',
  },
  {
    value: ALLOWED_FIELDS.ACH_FREQUENCY,
    label: '[achievement frequency]',
  },
  {
    value: ALLOWED_FIELDS.LAST_ACH_DATE,
    label: '[last achievement entered date]',
  },
  {
    value: ALLOWED_FIELDS.LAST_ACH_ENTERED,
    label: '[last achievement entered]',
  },
];
